import { render, staticRenderFns } from "./product-details.vue?vue&type=template&id=586bf428&scoped=true&"
import script from "./product-details.vue?vue&type=script&lang=js&"
export * from "./product-details.vue?vue&type=script&lang=js&"
import style0 from "./product-details.vue?vue&type=style&index=0&id=586bf428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586bf428",
  null
  
)

export default component.exports